import { Config } from "../config";
import { useApi } from "../composables/useApi";

export const useBapApi = useApi((args) => ({
  ...(args || {}),
  baseURL: Config.apiUrl,
}));
